module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "pane-header"
  }, [_vm._t("default", [_c('section', {
    staticClass: "pane-header__section--left"
  }, [(_vm.showBackButton) ? _c('button', {
    staticClass: "pane-header-button left",
    on: {
      "click": _vm.tools.navigate.goBack
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M15.5,19.75c-0.192,0-0.384-0.073-0.53-0.22l-7-7c-0.293-0.293-0.293-0.768,0-1.061l7-7c0.293-0.293,0.768-0.293,1.061,0\n\t\tc0.293,0.293,0.293,0.768,0,1.061L9.56,12l6.47,6.47c0.293,0.293,0.293,0.768,0,1.061C15.884,19.676,15.692,19.75,15.5,19.75z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Back")])]) : _vm._e(), _vm._v(" "), (_vm.showCloseButton) ? _c('button', {
    staticClass: "pane-header-button left",
    on: {
      "click": _vm.tools.navigate.goBack
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284\n                                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414\n                                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293\n                                    s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Close")])]) : _vm._e(), _vm._v(" "), (_vm.hasCloseSearchIcon) ? _c('button', {
    staticClass: "pane-header-button left",
    on: {
      "click": function () { return _vm.tools.actions.togglePane('search'); }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.hasCloseIcon) ? _c('button', {
    staticClass: "pane-header-button left",
    on: {
      "click": function () { return _vm.tools.actions.closePreviewPane(); }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.hasSearchIcon) ? _c('button', {
    staticClass: "pane-header-button left",
    on: {
      "click": function () { return _vm.tools.actions.togglePane('search'); }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.707,18.293l-4.049-4.048c1.838-2.521,1.628-6.081-0.647-8.355c-2.515-2.515-6.607-2.515-9.123,0\n\tc-2.515,2.515-2.515,6.608,0,9.123c1.258,1.258,2.91,1.886,4.562,1.886c1.335,0,2.667-0.418,3.793-1.239l4.049,4.048\n\tC18.488,19.902,18.744,20,19,20s0.512-0.098,0.707-0.293C20.098,19.316,20.098,18.683,19.707,18.293z M7.303,13.598\n\tc-1.735-1.735-1.735-4.56,0-6.295c0.868-0.868,2.007-1.301,3.147-1.301c1.14,0,2.279,0.434,3.147,1.301\n\tc1.735,1.735,1.735,4.56,0,6.295C11.862,15.333,9.039,15.333,7.303,13.598z"
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._t("left")], 2), _vm._v(" "), _c('section', {
    staticClass: "pane-header__section--center"
  }, [_c('section', {
    staticClass: "pane-header__title"
  }, [(_vm.appIconKey) ? _c('app-icon', {
    attrs: {
      "tools": _vm.tools,
      "name": _vm.appIconKey
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("title", [_vm._v(_vm._s(_vm.title))], {
    tag: "span"
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "pane-header__subtitle"
  }, [_vm._t("subtitle", [_vm._v(_vm._s(_vm.subtitle))], {
    tag: "span"
  })], 2)]), _vm._v(" "), _c('section', {
    staticClass: "pane-header__section--right"
  }, [_vm._t("right")], 2)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284\n                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414\n                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293\n                    s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284\n                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414\n                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293\n                    s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd7fe6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/PaneHeader.vue
// module id = 468
// module chunks = 1